import { FC } from 'react';

import { AnimationVideo } from '@/general/animations/AnimationVideo';
import { Link } from '@/general/components/Link/Link';

import { getPublicAssetUrl } from '../../helpers/getPublicAssetUrl';

type Props = {
  hideLogo?: boolean;
};

export const FullPageLoading: FC<Props> = ({ hideLogo }) => (
  <section>
    {!hideLogo && (
      <header className="mt-10 flex justify-center">
        <Link href="/">
          <img
            src={getPublicAssetUrl('/images/carma-logo-wordmark.svg')}
            alt="Carma"
            width="151"
            height="52"
            loading="lazy"
          />
        </Link>
      </header>
    )}
    <div className="mx-auto flex min-h-[calc(100vh-104px)] w-30 items-center justify-center">
      <AnimationVideo
        url={{
          webm: getPublicAssetUrl('/animations/CarSpinDark.webm'),
          mov: getPublicAssetUrl('/animations/CarSpinDark.mp4'),
        }}
        className="aspect-4/3 w-full"
        infinite
      />
    </div>
  </section>
);
